import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { icons } from '../../theme/icons';

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}

// Kept local rather than using mui-appshell's ThemeToggle: this one is driven by
// `useAppStateProperty('theme')`, which is the channel the MFEs read (ADR-0023).
export function ThemeToggle({ isDark, onToggle }: ThemeToggleProps) {
  const { t } = useTranslation();
  const label = isDark ? t('theme.switchToLight') : t('theme.switchToDark');

  return (
    <IconButton aria-label={label} title={label} aria-pressed={isDark} onClick={onToggle}>
      <FontAwesomeIcon icon={isDark ? icons.sun : icons.moon} />
    </IconButton>
  );
}
